import { render, staticRenderFns } from "./generalist-cta.vue?vue&type=template&id=9c48dbde&scoped=true"
import script from "./generalist-cta.vue?vue&type=script&lang=js"
export * from "./generalist-cta.vue?vue&type=script&lang=js"
import style0 from "./generalist-cta.vue?vue&type=style&index=0&id=9c48dbde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c48dbde",
  null
  
)

export default component.exports